export default __webpack_public_path__ + "static/media/rust.14f746d1.jpeg";